module.exports = __webpack_public_path__ + "img/19.ae459a14.jpg";